import React, { useRef, useState } from "react";
import EventoModel from "../../shared/model/evento.model";
import { Card } from "primereact/card";
import ReactPlayer from "react-player";
import DataTempoPipe from "../../../vendors/pipe/DataTempoPipe";
import DataPipe from "../../../vendors/pipe/DataPipe";

import "./index.scss";
import AnttButton from "../../../vendors/components/Button";
import { OverlayPanel } from "primereact/overlaypanel";
import { ShareModal } from "../ShareModal/ShareModal";


interface Props {
  evento: EventoModel;
  onHide: any;
  usuarioLogado?: boolean;
  tpReuniao?: number;
  isExpanded?: boolean;
  onExpandToggle?: () => void;
}

const EventoCard: React.FC<Props> = ({
  evento,
  onHide,
  usuarioLogado,
  tpReuniao,
  isExpanded,
  onExpandToggle,
}) => {
  const videoPadrao =
    evento.dsLinkVideo || "https://www.youtube.com/watch?v=r66Gh4nsnRI";

  // Exemplo de string vinda do banco
  const stringDoBanco = evento.dsResumo;

  // 1. Remover a tag <p> usando regex
  const stringSemPTag = stringDoBanco.replace(/<\/?p>/gi, "");

  // 2. Arrumar caracteres especiais (exemplo simples)
  const stringArrumada = stringSemPTag.replace(/[^\x20-\x7E]/g, "");

  const shareModalRef = useRef<OverlayPanel>(null);
  const [currentShareUrl, setCurrentShareUrl] = useState("");

  return (
    <Card className="evento-card">
      <div className="evento-card-video-wrapper">
        {/* Título "Dados do evento" com seta para expandir/recolher */}
        <div
          className="flex align-items-center mb-3"
          style={{ cursor: "pointer", userSelect: "none", paddingTop: '12px' }}
          onClick={onExpandToggle}
        >
          <i
            className={`pi ${isExpanded ? 'pi-angle-left' : 'pi-angle-right'}`}
            style={{ fontSize: '1.2rem' }}
          />
          <h3 style={{ marginLeft: '8px', marginBottom: 0, marginTop: 0 }}>
            Dados do evento
          </h3>
        </div>

        <div className="video-player" style={{ justifyContent: isExpanded ? 'flex-start' : 'center' }}>
          <ReactPlayer
            controls={true}
            className="video-player"
            url={videoPadrao}
          />
        </div>
        <div className="ml-2 mt-2">
          <div className="flex align-items-center justify-content-between">
            <h2 style={{ margin: 0 }}>
              {evento.nuAudienciaPublica}/{evento.nuAno}
            </h2>
            {!(evento.stEventoRestrito || Number(tpReuniao) === 1) && (
              <AnttButton
                disabled={!evento.dsLinkDivulgacaoEvento}
                className="p-button-rounded p-button-rounded-info"
                icon="pi pi-share-alt"
                tooltip="Compartilhar"
                tooltipOptions={{ position: "top" }}
                onClick={(e: any) => {
                  setCurrentShareUrl(evento.dsLinkDivulgacaoEvento);
                  shareModalRef.current?.toggle(e);
                }}
              />
            )}
          </div>
          <ShareModal ref={shareModalRef} url={currentShareUrl} />
          <div className="mt-2">
            <label>
              <b>
                {!!evento.cdTpEventoNavigation
                  ? evento.cdTpEventoNavigation.dsTpEvento
                  : ""}
              </b>{" "}
            </label>
            <div className="evento-resumo mt-2">
              <div style={{ display: "inline" }}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: isExpanded ? stringDoBanco : stringDoBanco.substring(0, 150) + (stringDoBanco.length > 150 ? "..." : ""),
                  }}
                />
              </div>

              {/* Conteúdo complementar que ficava no ModalVejaMais */}
              {isExpanded && (
                <div className="mt-4 p-3 border-round" style={{ backgroundColor: "var(--surface-ground)" }}>
                  <div>
                    <b>Situação: </b> {evento.codSituacaoAudienciaNavigation?.dsSituacaoAudiencia}
                  </div>
                  <div className="mt-2">
                    <label>
                      <b>Período: </b>{DataPipe({ value: evento.dtInicioValidade })} a {DataPipe({ value: evento.dtFimValidade })}
                    </label>
                  </div>
                </div>
              )}

            </div>
          </div>

          <br />
          <div>
            <div>
              <h3>{"Período de Recebimento de Contribuição"}</h3>
            </div>
            <div>
              <label>
                {DataTempoPipe({ value: evento.dtInicioValidade })} até{" "}
                {DataTempoPipe({ value: evento.dtFimValidade })}
              </label>
            </div>
          </div>
          <br />
          {evento.dtInicioValidadeHistorico !== "" &&
            evento.dtFimValidadeHistorico !== "" &&
            evento.codSituacaoAudiencia === 6 && (
              <div>
                <div>
                  <h3>{"Período de Reabertura de Contribuição"}</h3>
                </div>
                <div>
                  <label>
                    {DataTempoPipe({ value: evento.dtInicioValidadeHistorico })}{" "}
                    até{" "}
                    {DataTempoPipe({ value: evento.dtFimValidadeHistorico })}
                  </label>
                </div>
              </div>
            )}

          <br />
        </div>
      </div>
    </Card>
  );
};

export default EventoCard;
